import { Link } from 'react-router-dom'

import { styled } from '@mui/system'
import { alpha } from '@mui/material'

interface SidebarOrgSettingsLinkProps {
	readonly open?: boolean
}

const SidebarOrgSettingsLink = styled(Link, {
	shouldForwardProp: prop => prop !== 'open',
})<SidebarOrgSettingsLinkProps>(({ theme, open }) => ({
	fontSize: '2rem',
	width: '3rem',
	minWidth: '3rem',
	maxWidth: '3rem',
	borderRadius: '0.625rem',
	padding: '0.65rem 0.75rem 0.5rem 0.7rem',
	backgroundColor: open ? alpha(theme.palette.common.white, 0.1) : 'unset',
	margin: 'auto 0 2.5rem 0.25rem',
	display: 'flex',
	alignItems: 'center',
}))

export { SidebarOrgSettingsLink }
